import { useQuery } from "@tanstack/react-query";
import { QUERY_KEYS } from "app/data/common/queryKeys";
import { apiQueryAdapter } from "app/data/apiQueryAdapter";
import { useSelector } from "react-redux";
import { userSelector } from "slices/user/userSlice";
import { InboundPickupSummaryResponse } from "app/data/freights/model";

export const usePickupSummary = () => {
  const userState = useSelector(userSelector);

  const { isFetching, isLoading, data, error } =
    useQuery<InboundPickupSummaryResponse[]>({
      queryKey: [QUERY_KEYS.PICKUP_SUMMARY],
      queryFn: async () => {
        let params = { originTerminal: userState.activeTerminal?.id };

        const response = await apiQueryAdapter.query<InboundPickupSummaryResponse[]>("/pickups/inbound/summary",
          "GET",
          { params }
        );

        return response.data;
      },
    })
  return { isFetching, isLoading, data, error };
}